import Update from "../../table/Update"
import ApiService from "../../../services/apiService"
import { useParams } from "react-router-dom"
import {toast} from 'react-toastify'
import { useEffect,useState } from "react"
import { useNavigate } from "react-router-dom"
import { error } from "console"
const UpdateFarmer =() =>{
      
      const {Id} = useParams();
      const[farmerData, setFarmerData] = useState<[] |null| any>([])
      const[schemeVillage,setSchemeVillage] = useState<[] |null| any>()
      const navigate = useNavigate();
       
      const initialData ={
          FarmerName:farmerData?.farmerName,
          MobileNo:farmerData?.mobileNo,
          EmailAddress:farmerData?.emailAddress,
          Address:farmerData?.address,
          Scheme_Village:farmerData?.schemeVillage,
          villageId:farmerData?.villageId
      }

      useEffect(()=>{
           const farmer = async() =>{
                try{
                     const response = await ApiService.axiosApi(`farmer/${Id}`,{
                         method:'GET'
                     })
                     if(response.success){
                         setFarmerData(response.data)
                    }else{
                        console.log(response.message || "failed to fetch farmer data")
                    }
                }catch(e){
                     console.log(e)
                }
           }

           const schemeVillage = async() =>{
            try{
                const response = await ApiService.axiosApi(`/schemevillage`,{
                    method:"GET",
                    params:{
                         pageNumber :0,
                         pageSize:0
                    }
                })
                if(response.success){
                    setSchemeVillage(response.data.data);
                }
            }catch(error:any){
                toast.error(error.message|| "Failed to fetch Scheme Village");
            }
           }
            schemeVillage();
           farmer();
      },[])
      
      const updateFarmer = async (data:any)=>{
        try{

            const response =await ApiService.axiosApi(`/farmer/${Id}`,{
                method:"PUT",
                data:{
                    FarmerName:data.FarmerName,
                    MobileNo:data.MobileNo,
                    EmailAddress:data.EmailAddress,
                    Address:data.Address,
                    VillageId:data.VillageId
                }
            })
            if(response.success){
                
                toast.success(response.message|| "Khasara Updated");
                navigate(-1)
            }else{
                toast.error(response.message|| "Failed to update Khasara");
            }
        }catch(error:any){
            toast.error(error.message|| "Failed to update Khasara");
        }
        
    }

    return(
       
         <Update
            title={'Update Farmer'}
            parentTitle={'Farmer'}

            fields={[
                 {
                    name:"FarmerName",
                    label:"Name",
                    type:'text'
                 },
                 {
                    name:"MobileNo",
                    label:'Mobile',
                    type:'text'
                 },
                 {
                     name:"EmailAddress",
                     label:'Email',
                     type:'text'
                 },
                 {
                    name:'Address',
                    label:'Address',
                    text:'text'
                 },
                 {
                    name: "Scheme_Village",
                    label: "Scheme Village",
                    isDropdown:true,
                    dropdownData:schemeVillage,
                    dropdownLabel:"scheme_Village",
                    idFieldName:"VillageId"
                 }
                 
            ]}
            onSubmit={updateFarmer}
            initialData={initialData}
            
         />
       
    )
}

export default UpdateFarmer;